import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, Avatar } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import GoogleIcon from '@mui/icons-material/Google';

const reviews = [
  {
    id: 1,
    name: "David Thorne",
    avatar: "D",
    rating: 5,
    date: "2 weeks ago",
    project: "Quiz & Games App",
    text: "The quiz app is extremely engaging! Love the animations, score tracking, and smooth transitions. The developer really nailed the user interface. High professional standard!",
  },
  {
    id: 2,
    name: "Sarah Jenkins",
    avatar: "S",
    rating: 5,
    date: "3 weeks ago",
    project: "Fitness Gym App",
    text: "Outstanding workout tracking app. It is lightweight, extremely fast, and the custom routines are very easy to set up. A great mobile solution that has helped my gym routine significantly.",
  },
  {
    id: 3,
    name: "Liam Fitzpatrick",
    avatar: "L",
    rating: 5,
    date: "1 month ago",
    project: "MERN & Nest.js API",
    text: "Excellent backend architecture! The integration of NestJS with MongoDB is robust, secure, and highly scalable. Very impressive work and clean code structure.",
  },
  {
    id: 4,
    name: "Emma Watson",
    avatar: "E",
    rating: 5,
    date: "1 month ago",
    project: "Quiz & Games App",
    text: "Awesome mobile gaming app. The performance is incredibly smooth and the integration with Firebase database works perfectly. Highly recommend this developer!",
  },
  {
    id: 5,
    name: "Carlos Mendez",
    avatar: "C",
    rating: 5,
    date: "2 months ago",
    project: "Fitness Gym App",
    text: "Top-tier mobile application. The visual design is beautiful, responsive, and works flawlessly. Love the workout guides and the local data persistence setup.",
  }
];

const GoogleReviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box className="container my-5" sx={{ position: 'relative', zIndex: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 3 }}>
        <GoogleIcon sx={{ color: '#31F711', fontSize: '2.5rem' }} />
        <Typography variant="h4" sx={{ color: '#31F711', fontWeight: 'bold', textAlign: 'center' }}>
          Google Customer Reviews
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: '220px', position: 'relative' }}>
        {reviews.map((review, index) => {
          const isCurrent = index === currentIndex;
          return (
            <Box
              key={review.id}
              sx={{
                position: isCurrent ? 'relative' : 'absolute',
                opacity: isCurrent ? 1 : 0,
                transform: isCurrent ? 'scale(1)' : 'scale(0.95)',
                transition: 'opacity 0.6s ease-in-out, transform 0.6s ease-in-out',
                width: '100%',
                maxWidth: '600px',
                pointerEvents: isCurrent ? 'auto' : 'none',
                zIndex: isCurrent ? 2 : 1,
              }}
            >
              <Card
                sx={{
                  backgroundColor: 'rgba(20, 20, 20, 0.85)',
                  border: '2px solid #31F711',
                  borderRadius: '16px',
                  boxShadow: '0 8px 32px rgba(49, 247, 17, 0.15)',
                  backdropFilter: 'blur(10px)',
                  color: 'white',
                  p: 2,
                }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                      <Avatar sx={{ bgcolor: '#31F711', color: 'black', fontWeight: 'bold' }}>
                        {review.avatar}
                      </Avatar>
                      <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                          {review.name}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#aaa' }}>
                          {review.date}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      <Box sx={{ display: 'flex', color: '#FFD700' }}>
                        {[...Array(review.rating)].map((_, i) => (
                          <StarIcon key={i} fontSize="small" sx={{ color: '#31F711' }} />
                        ))}
                      </Box>
                      <Typography variant="caption" sx={{ color: '#31F711', fontWeight: 'bold', mt: 0.5 }}>
                        {review.project}
                      </Typography>
                    </Box>
                  </Box>

                  <Typography variant="body1" sx={{ fontStyle: 'italic', lineHeight: 1.6, color: '#f0f0f0' }}>
                    "{review.text}"
                  </Typography>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 2, justifyContent: 'flex-end' }}>
                    <GoogleIcon sx={{ fontSize: '14px', color: '#aaa' }} />
                    <Typography variant="caption" sx={{ color: '#aaa' }}>
                      Verified Review
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          );
        })}
      </Box>

      {/* Dots Indicator */}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 2 }}>
        {reviews.map((_, index) => (
          <Box
            key={index}
            onClick={() => setCurrentIndex(index)}
            sx={{
              width: currentIndex === index ? '12px' : '8px',
              height: currentIndex === index ? '12px' : '8px',
              borderRadius: '50%',
              backgroundColor: currentIndex === index ? '#31F711' : 'rgba(49, 247, 17, 0.3)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default GoogleReviews;
